<template>
  <div class="home_box">
    <el-container>
            <!-- 左侧 -->
        <el-aside width="220px">
            <Left></Left>
        </el-aside>
        <!-- 右侧 -->
        <el-container>
           
                <router-view></router-view>
            
        </el-container>
</el-container>
  </div>
</template>

<script>
import Left from "@/components/Left.vue";
export default {
  components: {
    Left
  }
};
</script>

<style lang="less" scoped>

</style>